window.baseUrl = "https://accounts.pixl.ai";
// landing APIS
window.resendConfirmationEmail = '/api/Email/resend-confirmation-email';
window.confirmEmail = '/api/Email/confirm-email';
window.emailConfirmationStatus = '/api/Email/CheckEmailConfirmationStatus';
window.registration = '/api/Account/register-client';
window.login = '/api/Account/Login';
window.salesEnquiry = '/api/Client/customer-enquiry';
window.forgotPassword = '/api/Account/forgot-password';
window.resetPassword = '/api/Account/reset-password';
window.validateResetPasswordUrl = '/api/Account/validate-reset-token';
window.getCountryCodes = '/api/Location/get-all-country-code';
//
window.productsList = '/api/Product/sub-products';
window.subProductCategories = '/api/Product/subproduct-categories';
window.creditUsage = '/api/Hit/credit-usage ';
